import React from 'react';

interface ToastCloseButtonProps {
    closeToast?: () => void;
}

const ToastCloseButton: React.FC<ToastCloseButtonProps> = ({ closeToast }) => (
    <button
        type="button"
        className="app-toast-close"
        aria-label="Dismiss notification"
        onClick={(event) => {
            event.stopPropagation();
            if (closeToast) closeToast();
        }}
    >
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
    </button>
);

export default ToastCloseButton;
